import { dragdrop } from 'lib/drag-drop';
import { appUI } from 'lib/app-ui';
import { tui } from 'lib/toolbar-ui';
import { pui } from 'lib/perspectives-ui';
import presentationUI from 'lib/presentation-ui';
import debounce from 'lodash.debounce';
import throttle from 'lodash.throttle';
import EventTracker from 'lib/event-tracking';
import { regionUI } from 'lib/region-ui';

class ZoomUI {
  constructor() {
    this.semanticZoomEnabled = true;

    this.isClickedFlag = null;
    this.panZoomDisabledElements = ['tag-legend', 'tools-sidebar', 'tag-popover', 'sidebar', 'lightbox', 'modal-image','node-perspectives-panel','node-attribute-editor','modal-import','modal-share','notifications','comments-scroll-container', 'modal-invite'];
    this.minScale = 0.15;
    this.maxScale = 4;
    this.rangeStep = 0.025; // used when dragging the slider or trackpad/mouse wheel
    this.increment = 0.05; // used when hitting the + or - buttons
    this.currentScale = 1;
    this.isPanningZooming = false; // true only when we're actually truly zooming

    this.ZOOM_THRESHOLD_0 = 0.40;

    this.ZOOM_THRESHOLD_CLASS_0 = 'zoom-threshold-0';

    this.minFontScale = 0.5;

    const self = this;
    this.panzoomzoomCallbackTimeout = null;
    this.panzoomchangeCallbackTimeout = null;

    this.panzoomzoomCallback = (e, panzoom, scale) => {
      if (self.panzoomzoomCallbackTimeout) {
        window.cancelAnimationFrame(self.panzoomzoomCallbackTimeout);
      }
      self.panzoomzoomCallbackTimeout = window.requestAnimationFrame(() => {
        const { $zoomIn, $zoomOut } = panzoom;
        self.zoomStyle();
        self.unsetPanzoomingFlag();
        self.isPanningZooming = false;

        if (scale <= this.minScale) {
          $zoomOut.addClass('zoom-button--disabled');
          $zoomIn.removeClass('zoom-button--disabled');
        } else if (scale >= this.maxScale) {
          $zoomIn.addClass('zoom-button--disabled');
          $zoomOut.removeClass('zoom-button--disabled');
        } else {
          $zoomIn.removeClass('zoom-button--disabled');
          $zoomOut.removeClass('zoom-button--disabled');
        }
      });
    };

    this.initZoomSteps();
    this.zoomStepNodeSizes = {};
  }

  initZoomSteps() {
    this.zoomSteps = [];
    const threshold = this.ZOOM_THRESHOLD_0;
    const minf = this.minFontScale;

    for (let scale = this.minScale; scale <= this.ZOOM_THRESHOLD_0; scale += this.rangeStep) {
      scale = this.refinePrecision(scale);
      const inverse = (scale * ((threshold - minf)/threshold) + minf) / scale;
      const zoomLevel = parseFloat(scale).toFixed(4);
      this.zoomSteps.push({scale, inverse, zoomLevel});
    }

    this.zoomSteps.reverse();
  }

  getZoomStepOverlaps(nodeId) {
    const zoomStepOverlaps = {};
    for (const step of this.zoomSteps) {
      const overlaps = this.getStepOverlapsForZoomLevel(step.zoomLevel,nodeId);
      if (overlaps && overlaps.length) {
        zoomStepOverlaps[step.zoomLevel] = overlaps;
      } else {
        zoomStepOverlaps[step.zoomLevel] = null;
      }
    }
    return zoomStepOverlaps;
  }

  getStepOverlapsForZoomLevel(zoomLevel,nodeId) {
    const nodeSignPostBoxes = this.zoomStepNodeSizes[zoomLevel];
    if (!nodeSignPostBoxes) {
      return;
    }
    const targetBox = nodeSignPostBoxes[nodeId];
    const overlaps = [];
    for (const id in nodeSignPostBoxes) {
      if (id === nodeId) {
        continue;
      }
      if (!targetBox || !nodeSignPostBoxes[id]) {
        continue;
      }
      /* check if one precomputed signpost footprint intersects another */
      if (nodeSignPostBoxes[id] && dragdrop.hit(targetBox,nodeSignPostBoxes[id])) {
        overlaps.push(id);
      }

    }
    return overlaps;
  }

  disableSemanticZoom() {
    this.semanticZoomEnabled = false;
    this.clearZoomStyle();
    this.canvas.realignAllLinks();
  }

  enableSemanticZoom() {
    this.semanticZoomEnabled = true;
    this.zoomStyle();
    this.canvas.realignAllLinks();
  }

  setCanvas(canvas) {
    this.canvas = canvas;
  }

  getMatrix() {
    const matrix = $(self.canvas.refs.canvas).panzoom('getMatrix');
    if (matrix) {
      matrix[4] = parseFloat(matrix[4]) + 5000;
      matrix[5] = parseFloat(matrix[5]) + 5000;
      matrix.scale = matrix[0];
      matrix.tx = matrix[4];
      matrix.ty = matrix[5];
      return matrix;
    } else {
      return { scale: 1, ty: 0, tx: 0 };
    }
  };

  setPanzoomMatrix(matrix) {
    $(self.canvas.refs.canvas).panzoom('setMatrix', matrix);
  }

  getOriginalPanzoomMatrix() {
    return $(self.canvas.refs.canvas).panzoom("getMatrix");
  }

  // round value to the nearest scale tick
  roundScale(scale) {
    const { rangeStep } = this;
    return Math.floor( (scale * 10000) / (rangeStep * 10000) ) * rangeStep;
  }

  setPanzoomingFlag() {
    // this.disabledWhenPanning().forEach(tag => {
    //   if (this.canvas.tags[tag] && this.canvas.tags[tag].root && this.canvas.tags[tag].root.classList) {
    //     this.canvas.tags[tag].root.classList.add('pe-none');
    //   }
    // });
  };


  disablePanZoomOnElementFromEvent(e) {
    // return true if the event target or any of its parents are in our disabled list.
    return this.panZoomDisabledElements.some((panZoomDisabledElement) => {
      // check event target
      let el = e.target;
      if (el.localName === panZoomDisabledElement) {
        return true;
      }

      // check the parents (all the way up the chain).
      while (el = el.parentElement) {
        if (el.localName === panZoomDisabledElement) {
          return true;
        }
      }

      return false;
    });
  }

  disabledWhenPanning() {
    return ['app-header','tag-legend-context-menu','tag-legend-popover','external-link-popover'];
  }

  unsetPanzoomingFlag() {
    //this.canvas.refs.app.classList.remove('pe-none');

    // this.disabledWhenPanning().forEach(tag => {
    //   if (this.canvas.tags[tag] && this.canvas.tags[tag].root && this.canvas.tags[tag].root.classList) {
    //     this.canvas.tags[tag].root.classList.remove('pe-none');
    //   }
    // });
  };

  initializePanZoom() {
    const self = this;

    if ((window.user && !window.user.settings.semantic_zoom) || window.pageSettings.disableSemanticZoom) {
      this.disableSemanticZoom();
    }

    let panzoomable = e => {
      return e.target.classList.contains("panzoomable");
    };

    let panZoom = $(this.canvas.refs.canvas).panzoom({
      canvasSize: {height: 10000, width: 10000},
      panzoomable,
      dims: {height: 20000, width: 20000},
      linearZoom: true,
      minScale: self.minScale,
      maxScale: self.maxScale,
      rangeStep: self.rangeStep,
      increment: self.increment,
      transition: true,
      animate: false,
      $zoomIn: $('#zoom-in'),
      $zoomOut: $('#zoom-out'),
      cursor: 'default',
      focal: {
        clientX:  $(window).width() / 2,
        clientY:  $(window).height() / 2,
      }
    });
    let instance = panZoom.panzoom('instance');
    instance.parentOffset = { top: 0, left: 0 };

    self.panzoom = $(self.canvas.refs.canvas).panzoom;
    $(self.canvas.refs.canvas).on('panzoomstart', e => {
      self.canvas.hidePopups({panzoomStart: true});
      self.isClickedFlag = true;
      self.canvas.selectionArea.resetSelectionBox();
      // Block firefox node creation
      // this.refs.nodes.style.pointerEvents = 'none';
      self.canvas.clearHoveredNode();
      window.getSelection().empty();
      self.canvas.hidePopups({panzoomStart: true});
      if (!presentationUI.isPaused()) {
        presentationUI.pause();
      };

      const excludedClasses = ['title', 'summary', 'perspective-title', 'bulk-group','focusable'];
      if (e.target && (excludedClasses.some(thisClass => e.target.classList.contains(thisClass)) || e.target.tagName == 'INPUT')) {
        return;
      }
      this.canvas.dummyInputTag.focus();
    });
    $(self.canvas.refs.canvas).on('panzoomend', e => {
      if (self.isClickedFlag) {
        // this was a click on the canvas - clear selected elements and delete extraneous empty nodes
        const latestNode = self.canvas.nodeTags[self.canvas.lastNodeCreatedWithEnterKey];
        if (latestNode && latestNode.title.trim() === '' && (latestNode.summary === null || latestNode.summary.trim() === '')) {
          if (latestNode.refs.title && latestNode.refs.summary
              && latestNode.refs.title.innerText.trim() === ''
              && latestNode.refs.summary.innerText.trim() === '') {
            self.canvas.deleteNode(latestNode.id, false);
          }
        }

        if (!e.ctrlKey) {
          // ctrl + click on trackpad opens right click

          if (this.canvas.rightClickMenuIsOpen() || tui.isSubmenuOpen() || this.canvas.commentsShown() || (this.canvas.notificationsTag && this.canvas.notificationsTag.isOpen)) {
            self.canvas.hidePopups();
          } else if (!e.shiftKey) {
            if (pui.hasPersistentPerspective()) {
              // click on the canvas exits active perspectives
              pui.unsetAllPerspectives();
            } else if (self.canvas.attributesTabTag && self.canvas.attributesTabTag.hasActiveAttribute()) {
              self.canvas.attributesTabTag.toggleOff();
            } else {
              self.canvas.clearSelectedElements();
              if (!self.canvas.floatingRLineTag.isHidden) {
                self.canvas.floatingRLineTag.hide();
              }
              self.canvas.linksTag.update();
            }
          }
        }
      } else {
        // this was a drag - don't clear selected elements
      }
      self.isClickedFlag = null;
      if (document.activeElement == document.body) {
        self.canvas.dummyInputTag.focus();
      }
      self.unsetPanzoomingFlag();
    });

    //self.debouncedPanzoomchangeCallback = debounce(self.panzoomchangeCallback,600,{trailing: true});

    $(self.canvas.refs.canvas).on('panzoomchange', (e) => { self.panzoomchangeCallback(e); });

    $(self.canvas.refs.canvas).on('panzoomzoom', (e, panzoom, scale) => {
      this.initialized = true;
      self.panzoomzoomCallback(e, panzoom, scale);
      document.body.style.setProperty('--app-scale', scale);
      $('#zoom-reset').text(`${scale === 1 ? 100 : parseInt(this.roundScale(scale) * 100, 10)}%`);
    });

    let isTouchpadDefined = false;
    let eventCount = 0;
    let eventCountStart;

    self.canvas.pointer = localStorage.getItem('pointer-type') || 'mouse';

    const { isMac } = self.canvas;
    const storedInvertPointer = localStorage.getItem('invert-scroll');

    self.canvas.invertScroll = storedInvertPointer ? JSON.parse(storedInvertPointer) : Boolean(isMac);

    // if we're an embedded map someone is likely scrolling down the page
    // the mousewheel.  We don't want that to zoom folks to never-never land.
    if (!window.pageSettings.disableTrackpad) {
      self.canvas.refs.app.addEventListener('wheel', (e) => {
        self.isMouseWheel = true;
        self.isClickedFlag = null;
        self.isPanningZooming = true;
        if (e.ctrlKey || self.canvas.pointer === 'mouse') {
          if (!self.disablePanZoomOnElementFromEvent(e)){
            e.preventDefault();
            e.stopPropagation();
            window.requestAnimationFrame(() => {
              if ($(self.canvas.refs.canvas).panzoom('isDisabled')) {
                $(self.canvas.refs.canvas).panzoom('enable');
              }
              var delta = e.delta || e.wheelDelta;
              var zoomOut = delta ? delta < 0 : e.deltaY > 0;
              var panZoom = $(self.canvas.refs.canvas).panzoom('zoom', zoomOut, {
                increment: self.roundScale(Math.abs(e.wheelDelta / 10000)) || self.rangeStep,
                animate: false,
                transition: false,
                focal: e
              });
              var instance = panZoom.panzoom('instance');
              instance.parentOffset = { top: 0, left: 0 };
            });
          }
        } else {
          if (!self.disablePanZoomOnElementFromEvent(e)){
            e.preventDefault();
            e.stopPropagation();
            window.requestAnimationFrame(() => {
              if ($(self.canvas.refs.canvas).panzoom('isDisabled')) {
                $(self.canvas.refs.canvas).panzoom('enable');
              }
              let deltaX = e.deltaX / 2;
              let deltaY = e.deltaY / 2;
              if (e.deltaMode === 1) {
                //if firefox, a tick is 5 instead of 120 in chrome
                deltaX = e.deltaX * 12;
                deltaY = e.deltaY * 12;
              }

              if (e.shiftKey) {
                // swap axes if the shift key is down, like how browsers do natively
                const tmp = deltaX;
                deltaX = deltaY;
                deltaY = tmp;
              }

              if (self.canvas.invertScroll === true) {
                deltaX *= -1;
                deltaY *= -1;
              }

              $(self.canvas.refs.canvas).panzoom("pan", deltaX, deltaY, {relative: true, animate: false});
            });
          }

        }
      });
    }
  }

  // e.g. take 2.0000000001 and make it 2
  refinePrecision(dirtyFloat) {
    return parseFloat(parseFloat(dirtyFloat).toFixed(4));
  }

  getZoomSteps() {
    return this.zoomSteps;
  }

  clearZoomStyle() {
    const { canvas } = this.canvas.refs;
    canvas.classList.remove(this.ZOOM_THRESHOLD_CLASS_0);
    canvas.removeAttribute('data-zoom-level');
  }

  // add classes to top level element at different zoom levels

  zoomStyle() {
    if (!this.semanticZoomEnabled) {
      return;
    }

    const { scale } = this.getMatrix();
    const { ZOOM_THRESHOLD_CLASS_0 } = this;
    const { canvas } = this.canvas.refs;
    const { classList } = canvas;

    this.currentScale = parseFloat(scale);
    /*
      note: if these change, modify list in export-menu.html->_prepareHtml()
    */
    if (scale <= this.ZOOM_THRESHOLD_0) {
      if (!classList.contains(ZOOM_THRESHOLD_CLASS_0)) {
        classList.add(ZOOM_THRESHOLD_CLASS_0);
      }
    } else {
      if (classList.contains(ZOOM_THRESHOLD_CLASS_0)) {
        classList.remove(ZOOM_THRESHOLD_CLASS_0);
      }
    }

    if (scale) {
      canvas.setAttribute('data-zoom-level', parseFloat(this.roundScale(scale)).toFixed(4));
    }
  }

  panzoomchangeCallback(e) {
    if (this.panzoomchangeCallbackTimeout) {
      window.cancelAnimationFrame(this.panzoomchangeCallbackTimeout);
    }
    this.panzoomchangeCallbackTimeout = window.requestAnimationFrame(() => {
      canvas.hidePopups({panzoomChange: true});
      this.zoomStyle();
      canvas.matrix = this.getMatrix();

      // we're dragging, so this was not a click
      this.isClickedFlag = null;

      // update region bg colors as we zoom
      this.canvas.regionsTag.update();

      if (!this.canvas.floatingRLineTag.isHidden) {
        this.canvas.floatingRLineTag.update();
      };

      if (this.canvas.dragging) {
        const showingDropzone = dragdrop.showingDropzone;
        dragdrop.hideDropzone(this.canvas.refs.dropzone);
        dragdrop.calculateTargetRects();
        if (showingDropzone) {
          dragdrop.showLastDropzone();
        }
      }
      if (!this.isPanningZooming && !this.isMouseWheel) {
        this.setPanzoomingFlag();
        this.isPanningZooming = true;
      }
      this.isMouseWheel = false;
      this.recentlyZoomed = true;
      if (this.recentlyZoomedTimeout) {
        clearTimeout(this.recentlyZoomedTimeout);
        this.recentlyZoomedTimeout = null;
      }
      this.recentlyZoomedTimeout = setTimeout(() => {
        this.recentlyZoomed = false;
      },600)
    });
  }

  resetZoom() {
    $(self.canvas.refs.canvas).panzoom('zoom', 1);
  }
}

// singleton instance
const zoomUI = new ZoomUI();
window.zoomUI = zoomUI;
export { ZoomUI, zoomUI };



// WEBPACK FOOTER //
// ./starling/src/lib/zoom-ui.js